import type { MonitorConfig } from '@kmi/kmijs';
import { RequestConfig } from '@kmi/react';
import { message } from '@m-ui/react';
import { commonPVMap } from 'utils/pvurlmap';
import urlParse from 'url';

const MODEL_RESPONSE_CODE = [200, 8001, 8002, 8003, 8004]; // 建模后端服务返回的 Code，预期内

export const monitorConfig: MonitorConfig = {
    // 返回 true 表示上传
    autoPVFilter: (currentUrl, prevUrl, type) => {
        const { pathname } = urlParse.parse(String(currentUrl), true);
        // 当前 url，前一个 url，pv 子类型 enter|leave|hidden|visible
        if (pathname === '/population' || pathname === '/market/my_population') {
            return false; // false 表示不上报
        }
        return true; // true 表示上报
    },
    // weblogger 配置，分别对应第一个和第二个参数
    weblogger: {
        logConfig: {
            // WeblogInitParams[0]
            urlMap: commonPVMap,
        },
    },
};

export const request: RequestConfig = {
    responseInterceptors: [
        (res: any) => {
            const { data } = res;
            if (
                (data && (+data.result === 1 || +data.result === 200)) ||
                (data && +data.code === 200) ||
                (data && +data.status === 200) ||
                MODEL_RESPONSE_CODE.includes(Number(data.code)) // 人群优选是另外的一套后端服务，需要根据 code 判断
            ) {
                return res;
            }
            if (data && +data.result !== 200 && data.message) {
                message.error(data.message);
            }
            return Promise.reject(data);
        },
    ],
};
